import SlideFrame from './SlideFrame';

interface SkillCat { cat: string; items: string[]; color: 'accent' | 'teal' | 'amber' | 'purple' }
interface Workflow { cmd: string; desc: string }

interface Props {
  title: string; sub: string;
  skills_t: string; workflows_t: string;
  skills: SkillCat[];
  workflows: Workflow[];
}

const CAT_COLORS: Record<string, string> = {
  accent: 'var(--col-a)',
  teal: 'var(--col-b)',
  amber: 'var(--col-c)',
  purple: '#7B3FA0',
};

export default function SkillsWorkflows({ title, sub, skills_t, workflows_t, skills, workflows }: Props) {
  return (
    <SlideFrame title={title} sub={sub}>
      <div className="sw-grid">
        <div className="sw-section">
          <div className="sw-section-title">{skills_t}</div>
          <div className="sw-skills">
            {skills.map((cat, i) => (
              <div key={i} className="sw-cat" style={{ borderLeftColor: CAT_COLORS[cat.color] }}>
                <div className="sw-cat-name" style={{ color: CAT_COLORS[cat.color] }}>{cat.cat}</div>
                <div className="sw-items">
                  {cat.items.map((item, j) => <span key={j} className="sw-item">{item}</span>)}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="sw-section">
          <div className="sw-section-title">{workflows_t}</div>
          <div className="sw-workflows">
            {workflows.map((wf, i) => (
              <div key={i} className="sw-wf-row">
                <code className="sw-wf-cmd">{wf.cmd}</code>
                <span className="sw-wf-desc">{wf.desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SlideFrame>
  );
}
